module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/theme/packages/core-app/src/templates/formErrorListView.html -->\n<div class="container">\n	<header>\n		<h2 class="title"><span class="text">Please fill out all mandatory attributes</span></h2>\n	</header>\n	<div class="nx-childviews"></div>\n</div>';
}
return __p;
};
